import { MultiSelectItem } from "./multi-select";

export class MultiSelectHarnessController {
  public menuItems: MultiSelectItem[];

  constructor() {
    this.menuItems = [
      { displayName: "Service Desk Click 1", value: 1, isSelected: false },
      { displayName: "Service Desk Click 2", value: 2, isSelected: true },
      { displayName: "Service Desk Click 3", value: 3, isSelected: true },
      { displayName: "Service Desk Click 4", value: 4, isSelected: false }
    ];
  }

  public menuItemSelected(menuItem: MultiSelectItem): void {
    console.info(`${menuItem.displayName} was clicked`);
  }
}
